import SummaryPricesDiscounts from 'components/summary-prices-discounts';
import { Discount } from 'interfaces/order';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Price from '../../../../components/price';

interface PropTypes {
  containsPreorderItem: boolean;
  containsPreorderItemsOnly: boolean;
  canToggleCredits?: boolean;
  hasExistingSubscription?: boolean;
  itemsTotal?: number;
  cartTotal?: number;
  discount?: Discount;
  shippingPrice?: number;
}

const SummaryPrices: React.FC<PropTypes> = ({
  canToggleCredits = false,
  cartTotal,
  containsPreorderItem,
  containsPreorderItemsOnly,
  discount,
  hasExistingSubscription = false,
  itemsTotal,
  shippingPrice,
}) => {
  if (!cartTotal || !itemsTotal || typeof shippingPrice !== 'number') return null;

  return (
    <>
      <div className="text-primary-main px-6 pt-4 pb-2 font-medium">
        {containsPreorderItem && (
          <h2 className="mb-3 font-medium text-red-600">
            <FormattedMessage
              id={
                containsPreorderItemsOnly
                  ? 'cart:preorder-only-shipping-delay'
                  : 'cart:preorder-mixed-shipping-delay'
              }
            />
          </h2>
        )}

        <div className="flex justify-between text-sm">
          <div>
            <FormattedMessage id="cart:sub-total" />
          </div>
          <Price cents value={itemsTotal} />
        </div>

        {!hasExistingSubscription && (
          <div className="flex justify-between text-sm">
            <div>
              <FormattedMessage id="cart:shipping" />
            </div>
            {shippingPrice === 0 ? (
              <FormattedMessage id="cart:summary:shipping:free" />
            ) : (
              <Price cents value={shippingPrice} />
            )}
          </div>
        )}

        <SummaryPricesDiscounts canToggleCredits={canToggleCredits} discount={discount} />
      </div>

      <div className="bg-brand-tint mt-2 flex justify-between rounded-b-lg px-6 py-3">
        <div>
          <strong className="text-primary-main">
            <FormattedMessage id="cart:total" />
          </strong>
          <div className="text-sm">
            <FormattedMessage id="cart:tax" />
          </div>
        </div>
        <strong className="text-primary-main text-3xl">
          {hasExistingSubscription ? (
            <Price cents value={cartTotal - shippingPrice} />
          ) : (
            <Price cents value={cartTotal} />
          )}
        </strong>
      </div>
    </>
  );
};

export default SummaryPrices;
